// src/pages/UserManagement.js
import React, { useState, useContext } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { AuthContext } from "../context/AuthContext";
import axiosInstance from "../utils/axiosInstance";
import Logo from "../assets/logo1.png";
import RegisterForm from "./RegisterForm";
import InitSuperAdminForm from "./InitSuperAdminForm";
import { logger } from "../utils/logger";

const UserManagement = ({ open, onClose }) => {
  const { auth } = useContext(AuthContext);
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    role: "user",
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isFirstUser, setIsFirstUser] = useState(false); // Set this based on API or logic

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      logger.info("Attempting to create user", {
        type: isFirstUser ? "Superadmin" : "Admin/Editor",
        formData: { ...formData, password: "***" }, // mask password
        performedBy: auth?.user?.username,
        role: auth?.user?.role,
      });
      await axiosInstance.post("api/user/create", formData, {
        headers: { Authorization: `Bearer ${auth.token}` },
      });
      logger.info("User created successfully", {
        type: isFirstUser ? "Superadmin" : "User",
        username: formData.username,
        email: formData.email,
        role: formData.role,
        performedBy: auth?.user?.username,
      });
      setFormData({ username: "", email: "", password: "", role: "user" });
    } catch (err) {
      logger.error("Error creating user", {
        type: isFirstUser ? "Superadmin" : "User",
        error: err.message || err,
        formData: { ...formData, password: "***" },
        performedBy: auth?.user?.username,
        role: auth?.user?.role,
      });
    }
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingRight: 2,
            paddingBottom: 2,
          }}
        >
          <Typography variant="h6">
            {isFirstUser ? "Create First Superadmin" : "Create New User"}
          </Typography>
          <IconButton edge="end" onClick={onClose} data-log="Close Icon Button">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap={2}
          >
            {isFirstUser ? (
              <img
                src={Logo}
                alt="Logo"
                style={{ width: "80px", marginBottom: "10px" }}
              />
            ) : (
              <h4 style={{ marginBottom: "0px" }}></h4>
            )}

            {isFirstUser ? (
              <InitSuperAdminForm
                formData={formData}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
              />
            ) : (
              <RegisterForm
                formData={formData}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
              />
            )}
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default UserManagement;
